<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2022-01-07 17:55:02
 * @FilePath: \mrc-base-frontend\src\views\pushMessageTopic\addMessageTopic.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-10 09:46:38
-->
<template>
  <div>
    <Info :disabled="disabled" @add="newTopic" />
  </div>
</template>
<script>
import { addMessageTopicDetail } from "@/service/api/pushMessageTopic";
import Info from "./modules/info.vue";
export default {
  components: { Info },
  data() {
    return {
      disabled: false,
    };
  },
  mounted() {},
  methods: {
    async newTopic(obj) {
      await addMessageTopicDetail(this.$clone(obj)).then((res) => {
        if (res.code == 200) {
          this.$Message({ text: this.$t("message_added_successfully") });
          this.$router.push({
            name: "pushMessageTopic",
          });
        }
      });
    },
  },
};
</script>